import React from 'react';
import { useSelector } from 'react-redux';
import MaterialTable from 'material-table';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { Query, useApolloClient } from 'react-apollo';
import moment from 'moment';
import { UPCOMING_MEETINGS } from 'graphql/admin/users';
import { CONF_HISTORY } from 'graphql/conference';
import { toUserTimezone } from 'utils';
import { USER_TYPES } from 'constant/userTypes';
import uniqBy from 'lodash/uniqBy';
import humanDuration from 'humanize-duration';

const Home = ({ history }) => {
  const user = useSelector((s) => s.user.user);
  const client = useApolloClient();

  const start = moment().toJSON();
  const end = moment()
    .add(1, 'd')
    .toJSON();

  return (
    <div>
      <Typography variant={'h4'} gutterBottom>
        Welcome {user.fname}!
      </Typography>
      <Box marginTop={3}>
        <Query
          query={UPCOMING_MEETINGS}
          fetchPolicy={'cache-and-network'}
          variables={{
            start,
            type: ['hc', 'circle_hc'],
            coach: {
              hc_id: {
                _eq: user.id,
              },
            },
          }}
        >
          {({ data, loading }) => {
            const columns = [
              {
                title: 'Student name',
                render: (row) => `${row.user.name} ${row.user.user_last_name}`,
              },
              { title: 'Meeting', field: 'exercise.name' },
              {
                title: 'Scheduled at',
                field: 'due_date',
                render: (row) =>
                  toUserTimezone(row.due_date, user.timezone).format('LLL'),
              },
            ];

            return (
              <MaterialTable
                title="Upcoming Sessions"
                isLoading={loading}
                columns={columns}
                data={data?.rows}
                options={{
                  search: false,
                  paging: false,
                }}
                actions={[
                  {
                    icon: 'visibility',
                    tooltip: 'View Student Profile',
                    onClick: (event, rowData) =>
                      history.push(`/students/${rowData.user_id}/profile`),
                  },
                ]}
                localization={{
                  body: {
                    emptyDataSourceMessage:
                      'Nothing scheduled in next 24 hours',
                  },
                }}
              />
            );
          }}
        </Query>
      </Box>
      <Box marginTop={3}>
        <MaterialTable
          title="Past Sessions"
          columns={[
            {
              title: 'ID',
              field: 'id',
              sorting: false,
            },
            {
              title: 'Date',
              field: 'created_at',
              defaultSort: 'desc',
              render: (row) =>
                toUserTimezone(row.created_at, user.timezone).format('LLL'),
            },
            {
              title: 'Duration',
              field: 'duration',
              render: (row) =>
                humanDuration(row.duration * 1000, {
                  units: ['m'],
                  round: true,
                }),
            },
            {
              title: 'Participants',
              sorting: false,
              render: (data) => {
                return (
                  <Box>
                    {uniqBy(
                      data.conference_participants.map((u) => u.user),
                      'user_id',
                    ).map((i) => (
                      <Box>
                        <Typography variant="body2">
                          {i.name} (
                          {USER_TYPES[i.user_type]})
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                );
              },
            },
          ]}
          data={(query) => {
            return client
              .query({
                query: CONF_HISTORY,
                variables: {
                  limit: query.pageSize,
                  offset: query.page * query.pageSize,
                  order: [{ [query.orderBy.field]: query.orderDirection }],
                  userSub: user.sub,
                },
              })
              .then((resp) => {
                return {
                  data: resp.data.rows,
                  totalCount: resp.data.count.aggregate.count,
                  page: query.page,
                };
              });
          }}
          options={{
            search: false,
            pageSize: 10,
          }}
          actions={[
            {
              icon: 'play_circle_outline',
              tooltip: 'View Recording',
              onClick: (event, rowData) =>
                history.push(`meeting/${rowData.id}/view`),
            },
          ]}
        />
      </Box>
    </div>
  );
};
export default Home;
